import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GoogleMapsModule } from '@angular/google-maps'
import { BrowserModule, Title } from '@angular/platform-browser';
import { UserClient } from '@shared/services/user/user-client.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CoreModule,
    AppRoutingModule,
    GoogleMapsModule,
    BrowserModule
  ],
  providers: [ 
    UserClient
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
